<template>
  <div id="product-list">
    <div class="vx-card p-2">
      <div class="vx-row mb-3">
        <!-- Select product category -->
        <div class="vx-col max-w-xs w-full">
          <select-2 class="" autocomplete :value="productCategory" @input="(item) => (productCategory = item.value)" :extra="[{ label: 'All', value: null }]" :options="productCategories" />
        </div>
        <!-- product filter -->
        <div class="con-input-search vs-table--search relative ml-5">
          <input class="input-search vs-table--search-input text-base px-4 pl-8 py-2" type="text" v-model="search" style="border: 1px solid rgba(0, 0, 0, 0.3)" />
          <vs-icon icon="search" class="absolute"></vs-icon>
        </div>
      </div>

      <!-- product list  -->
      <div class="product_list__table p-1 vs-con-tbody vs-table--tbody vs-con-table stripe pt-0">
        <table id="item__list" class="w-full vs-table vs-table--tbody-table">
          <thead class="vs-table--thead">
            <tr>
              <th class="sticky top-0 text-white shadow-2xl">Item Name</th>
              <th class="sticky top-0 text-white shadow-2xl">Batch Number</th>
              <th class="sticky top-0 text-white shadow-2xl">Category</th>
              <th class="sticky top-0 text-white shadow-2xl">Weight Type</th>
              <th class="sticky top-0 text-white shadow-2xl">Weight Per Package</th>
              <th class="sticky top-0 text-white shadow-2xl">Quantity</th>
              <th class="sticky top-0 text-white shadow-2xl">Price</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tr-values vs-table--tr tr-table-state-null selected" @click="addItemInPos(tr.id)" :key="i" v-for="(tr, i) in products">
              <td class="td vs-table--td">
                <span>{{ tr.product_name }}</span>
              </td>
              <td class="td vs-table--td">
                <span>{{ tr.batch && tr.batch.batch_number }}</span>
              </td>

              <td class="td vs-table--td">
                <span>{{ tr.category && tr.category.category_name }}</span>
              </td>
              <td class="td vs-table--td">
                <span>{{ tr.weight_type }}</span>
              </td>
              <td class="td vs-table--td">
                <span>{{ mathRound([categories.FLOWER, categories.SHAKE].includes(tr.categoryId) ? tr.quantity : tr.weight_per_package, 3) }}</span>
              </td>
              <td class="td vs-table--td">
                <span> {{ [categories.FLOWER, categories.SHAKE].includes(tr.categoryId) ? '-' : mathRound(tr.quantity, 3) }}</span>
              </td>
              <td class="td vs-table--td">
                <span>{{ tr.sales_price | currencyFilter }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- category list -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { weightMixins } from '@/utils/weightType'
import defaultImage from '@/assets/images/pr_default.jpg'
import { DEMORETAILER } from '@/utils/roles.js'
import _ from 'lodash'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'ProductList',

  components: {
    Select2
  },

  // data
  data() {
    return {
      search: '',
      productCategories: [],
      productCategory: null,
      categoryTaxes: [],
      limit: 20,
      page: 1,
      DEMORETAILER,
      is_global: 'global',
      loading: false
    }
  },

  async mounted() {
    // get product categories
    await this.getProductCategories()

    await this.fetchProductsFromCategory()

    const $elems = document.querySelector('.product_list__table')
    $elems.addEventListener('scroll', () => {
      if ($elems.scrollTop + $elems.clientHeight >= $elems.scrollHeight - 5) {
        this.scrollYEndHandle()
      }
    })
  },

  computed: {
    ...mapState('pos', { product_grid_count: 'product_grid_count' }),
    ...mapState('product', { categories: 'categories' }),
    ...mapGetters('pos', { products: 'getProducts' }),
    ...mapState('auth', ['user']),

    supplierName() {
      return (product) => {
        return product.supplier_type === 'supplier' ? product.supplier.business_name : product.supplier.username
      }
    },

    searchProductList() {
      return {
        input: _.debounce((e) => {
          this.handleSetSearch(e)
        }, 600)
      }
    }
  },

  mixins: [weightMixins, paymentMixins],

  // methods
  methods: {
    ...mapActions('product', { fetchProductscategories: 'getProductCategories' }),
    ...mapActions('pos', { fetchProductsByCategory: 'getByCategory' }),
    ...mapMutations('pos', { addItemInProducts: 'ADD_PRODUCTS' }),

    // set search val
    handleSetSearch(val) {
      this.search = val
    },

    image(product) {
      if (product.images && product.images[0]) {
        return product.images && product.images[0] && product.images[0].image_path
      } else {
        return defaultImage
      }
    },

    // Get product category
    async getProductCategories() {
      this.loading = true
      const { is_global } = this
      try {
        const payload = {
          product_name: this.search,
          limit: 0,
          page: 1,
          order: ['id', 'ASC'],
          is_global: this.user.roleId === DEMORETAILER ? null : is_global,
          is_status: true
        }

        const res = await this.fetchProductscategories(payload)
        this.productCategories = [...res.data]
        this.productCategories = this.productCategories.reduce((acc, item) => {
          item.label = item.category_name
          item.value = item.id

          acc.push(item)

          return acc
        }, [])
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // fetch products from category id
    async fetchProductsFromCategory() {
      this.loading = true
      try {
        const params = {
          product_name: this.search,
          page: this.page,
          limit: this.limit,
          categoryId: this.productCategory
        }

        const { taxes } = await this.fetchProductsByCategory({
          params
        })
        this.loading = false
        this.$emit('setCategoryTaxes', taxes)
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    scrollYEndHandle() {
      if (!this.loading) {
        if (this.product_grid_count === 0 || this.product_grid_count > this.limit * this.page) {
          this.page++
          this.fetchProductsFromCategory()
        }
      }
    },

    clearFilter() {
      this.search = ''
      this.page = 1
      this.productCategory = null
      this.fetchProductsFromCategory()
    },

    // add item in invoice list
    async addItemInPos(productId) {
      // find product from product list using product id
      const tempProduct = this.products.find((x) => x.id === productId)
      // save added product in temp state for later use
      await this.addItemInProducts([tempProduct])
      // emit selected product in parent component
      this.$emit('product-clicked', productId)
    }
  },

  watch: {
    // set loading
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#product-list',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#product-list > .con-vs-loading')
      }
    },

    search() {
      this.page = 1
      this.fetchProductsFromCategory()
    },

    productCategory() {
      this.page = 1
      this.fetchProductsFromCategory()
    }
  },

  // filters
  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    },

    //currency filter rounded conversation
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>

<style lang="scss">
#container {
  position: relative;
  max-height: 700px;
  &.h-200 {
    overflow: auto;
    max-height: 465px;
  }
}

#product-list {
  .product_list__table {
    height: 200px;
    overflow: auto;

    table {
      thead {
        th {
          background: #006622;
          border: 1px solid white;
        }
      }
    }
  }
}
</style>